/** 저작 job 조회·취소 — B-2/B-6 라우트 소비. 판정은 백엔드가 하고 여기선 나르기만 한다. */
import { request, requestDownload } from '@/api/client'
import { API } from '@/api/paths'
import type { JobListResponse, ThreadJobResponse } from './types'

export async function fetchThreadJob(threadId: string): Promise<ThreadJobResponse> {
  return await request<ThreadJobResponse>(API.masterplanJob(threadId))
}

export async function fetchMyJobs(limit = 50): Promise<JobListResponse> {
  return await request<JobListResponse>(`${API.masterplanJobs}?limit=${limit}`)
}

export interface CancelResult {
  thread_id: string
  cancelled: boolean
  billed?: boolean
  detail: string
}

/** 중단 — **가역 조작이라 확인 게이트가 없다**. 비용 발생 여부는 응답의 `billed` 가 말한다. */
export async function cancelThreadJob(threadId: string): Promise<CancelResult> {
  return await request<CancelResult>(API.masterplanJobCancel(threadId), { method: 'POST' })
}

/**
 * 완성본 다운로드 — **3분기**다(B-2 확장분).
 * 파일이면 저장, 아직이면 진행 상태 JSON 이 온다. 판별은 `content-disposition`(D10 이관).
 */
export async function downloadMasterplan(threadId: string) {
  return await requestDownload(API.masterplanXlsx(threadId))
}

/** 브라우저 저장 — Blob → 임시 링크. 화면 로직이라 여기 둔다(호출부가 매번 만들지 않게). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
